<div class="faq-side-secton" [class.open]="openSidebar">
  <div class="faq-list-space">
    <ng-content></ng-content>
  </div>
  <div class="faq-toggle-icon" (click)="toggleSidebar();">
    @if (!openSidebar) {
      <i class="fas fa-question-circle"></i>
    }
    @if (openSidebar) {
      <i class="fas fa-caret-left"></i>
      }<br>
      <span>{{ 'LOGIN.FAQ-TOGGLE-TEXT' | translate }}</span>
    </div>
  </div>
